import React from 'react';
import I18n from 'i18n-js';
import URLHelpers from '../../shared/url_helpers';
import SanitizedRender from '@reverbdotcom/commons/src/components/sanitized_render';

import gql from 'graphql-tag';
import { CoreShopInfo } from '../../../schemas/rql';

interface Props {
  shop: CoreShopInfo.Shop;
}

export const ShopReturnPoliciesFragment = gql`
  fragment ShopReturnPoliciesFragment on Shop {
    _id
    userUuid
    returnPolicy {
      newReturnWindowDays
      usedReturnWindowDays
      restockingFeePercent
      specialConditions
    }
  }
`;

export default class ShopReturnPolicies extends React.Component<Props, null> {
  getMessageURL() {
    return URLHelpers.newDashboardMessagesPath(null, this.props.shop.userUuid);
  }

  hasPolicy() {
    return !!this.props.shop.returnPolicy;
  }

  renderReturnWindow(condition: 'new' | 'used') {
    const policy = this.props.shop.returnPolicy;
    const days = condition === 'new'
      ? policy.newReturnWindowDays
      : policy.usedReturnWindowDays;

    if (!days) {
      return (
        <p>
          {I18n.t('discovery.shopReturnPolicies.notReturnable')}
        </p>
      );
    }

    return (
      <p>
        {I18n.t('discovery.shopReturnPolicies.returnWindow', { days })}
        <br />
        {!!this.props.shop.returnPolicy.restockingFeePercent &&
          I18n.t('discovery.shopReturnPolicies.restockingFee', { amount: policy.restockingFeePercent })}
      </p>
    );
  }

  renderPolicy(condition) {
    return (
      <div data-return-policy>
        <h4 className="cms-h4 mb-half mt-0">
          {I18n.t(`discovery.shopReturnPolicies.${condition}`)}
        </h4>
        {this.renderReturnWindow(condition)}
      </div>
    );
  }

  renderNoPolicy() {
    return (
      <p data-no-returns>
        {I18n.t('discovery.shopReturnPolicies.noPolicies')}
        <a
          href={this.getMessageURL()}
          className="ml-space"
        >
          {I18n.t('discovery.shopReturnPolicies.noPoliciesMessage')}
        </a>
      </p>
    );
  }

  render() {
    const { shop } = this.props;
    if (!shop) return null;
    if (!this.hasPolicy()) return this.renderNoPolicy();

    return (
      <div>
        {this.renderPolicy('new')}
        {this.renderPolicy('used')}
        <h4 className="cms-h4 mb-half">
          {I18n.t('discovery.shopReturnPolicies.generalTerms')}
        </h4>
        <p>
          {I18n.t('discovery.shopReturnPolicies.generalTermsDescription')}
        </p>
        {shop.returnPolicy.specialConditions &&
          <div data-special-conditions>
            <h4 className="cms-h4 mb-half">
              {I18n.t('discovery.shopReturnPolicies.specialConditions')}
            </h4>
            <SanitizedRender
              html={shop.returnPolicy.specialConditions}
              htmlTag="p"
              convertNewlines
            />
          </div>
        }
        <div className="size-90 mt-2 opacity-80">
          {I18n.t('discovery.shopReturnPolicies.finePrint')}
        </div>
      </div>
    );
  }
}
